import { SearchSelect } from 'components/ui';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import remove from 'lodash/remove';
import i18n from 'i18n';
import { useTranslation } from 'react-i18next';

const CountrySelect = (props) => {
	const countries = useSelector((state) => state.masterData.countries);
	const [countryOptions, setCountryOptions] = useState([]);
	const [t] = useTranslation();

	useEffect(() => {
		if (!countries) {
			return;
		}
		const options = countries
			.slice()
			.filter((item) => {
				return item?.country_iso_code?.length == 2;
			})
			.map((country) => {
				if (country.country_name == 'Vereinigte Staaten') {
					return {
						...country,
						country_name: 'Vereinigte Staaten von Amerika (USA)',
					};
				} else {
					return country;
				}
			})
			.sort((a, b) => a.country_name.localeCompare(b.country_name));
		let germanSpeakingCountries = [];
		if (i18n.language.substring(0, 2) === 'de') {
			germanSpeakingCountries = remove(options, (country) => {
				return (
					country.country_iso_code == 'AT' ||
					country.country_iso_code == 'CH' ||
					country.country_iso_code == 'DE'
				);
			});
			germanSpeakingCountries.push({
				country_iso_code: 'DACH',
				country_name_en: 'Unknown - german-speaking area DACH',
				country_name_de: 'Unbekannt - deutschsprachiger Raum DACH',
				standard_language_name_foreign:
					'Unbekannt - deutschsprachiger Raum DACH',
				country_name: t('master_data.countries.unknown_dach'),
			});
			germanSpeakingCountries.push({
				country_iso_code: 'WORLD',
				country_name_en: 'Unknown - Worldwide',
				country_name_de: 'Unbekannt - Weltweit',
				standard_language_name_foreign: 'Unbekannt - Weltweit',
				country_name: t('master_data.countries.unknown_worldwide'),
			});
			germanSpeakingCountries.push({
				type: 'separator',
				text: t('common.weitere_laender'),
			});
			germanSpeakingCountries.unshift({
				type: 'separator',
				text: t('common.vorauswahl_browser_sprache'),
			});
		} else {
			germanSpeakingCountries.push({
				country_iso_code: 'DACH',
				country_name_en: 'Unknown - german-speaking area DACH',
				country_name_de: 'Unbekannt - deutschsprachiger Raum DACH',
				standard_language_name_foreign:
					'Unbekannt - deutschsprachiger Raum DACH',
				country_name: t('master_data.countries.unknown_dach'),
			});
			germanSpeakingCountries.push({
				country_iso_code: 'WORLD',
				country_name_en: 'Unknown - Worldwide',
				country_name_de: 'Unbekannt - Weltweit',
				standard_language_name_foreign: 'Unbekannt - Weltweit',
				country_name: t('master_data.countries.unknown_worldwide'),
			});
		}
		setCountryOptions(germanSpeakingCountries.concat(options));
	}, [countries]);

	const getCountryValue = () => {
		if (props.value) {
			return (
				countryOptions.find((land) => {
					return (
						props.value?.toLowerCase() == land.country_iso_code?.toLowerCase()
					);
				}) || {
					country_name_de: props.value,
				}
			);
		} else {
			return '';
		}
	};

	return (
		<SearchSelect
			label={props.label}
			displayProperty='country_name'
			valueProperty='country_iso_code'
			onChange={props.onChange}
			value={getCountryValue()}
			options={countryOptions}
			disableAdd={true}
			isInvalid={props.isInvalid}
		/>
	);
};

CountrySelect.propTypes = {
	label: PropTypes.string,
	value: PropTypes.string,
	onChange: PropTypes.func,
	isInvalid: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]),
};

export { CountrySelect };
